"use client";
import React from "react";
import { Group, HoverCard, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import Image from "next/image";
import { usePathname } from "next/navigation";

interface PlanRecommendationSupportProps {
  PhoneJsx?: React.ReactNode;
}

const PlanRecommendationSupport: React.FC<PlanRecommendationSupportProps> = ({
  PhoneJsx,
}) => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const pathName = usePathname();
  const isBecomeAnAgent = pathName === "/become-an-agent-portal.html";

  return (
    <div className="flex flex-row justify-between gap-2 z-2 text-xs mr-2" id="plan-recommendation-support">
      {!isBecomeAnAgent && (PhoneJsx ? (
        <>{PhoneJsx}</>
      ) : isMobile ? (
        <a id="mobile-phone-link" href="tel:1800-309-3333">
          <div id="mobile-phone-container" className="flex flex-row gap-1 pad:gap-2 justify-end items-center">
            <div id="mobile-phone-icon" className="bg-nivabupa-blue-ethinosPlanRecommendation py-2 px-2  md:py-2 md:px-5  h-[36px]  md:h-[40px] rounded-full md:rounded-3xl flex justify-center">
              <Image
                src="/aem-to-react/corporateInsurance/new-header-icons/header-icon-phone.svg"
                alt="phone"
                width={20}
                height={20}
              />
            </div>
            <p id="mobile-phone-text">
              New <br /> Policy
            </p>
          </div>
        </a>
      ) : (
        <a id="desktop-phone-link" href="tel:1800-309-3333">
          <div id="desktop-phone-container" className="flex flex-row gap-1 pad:gap-2 justify-end items-center p-2 rounded-3xl bg-nivabupa-blue-ethinosPlanRecommendation ">
            <div id="desktop-phone-icon" className="  pad:h-4 xs:h-4 h-3 pad:w-4 xs:w-4 w-3">
              <Image
                src="/aem-to-react/corporateInsurance/new-header-icons/header-icon-phone.svg"
                alt="phone"
                width={0}
                height={0}
                sizes="100vw"
                id="navbar-phone-icon-svg"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
            <div id="desktop-phone-text" className="flex flex-row gap-1 justify-end items-center whitespace-nowrap">
              <div className="text-white">For a New Policy</div>
              <div className="text-white font-bold">1800-309-3333</div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default PlanRecommendationSupport;
